// extracted by mini-css-extract-plugin
export var cardUnlocked = "CardUnlocked-module--cardUnlocked--1Myo2";
export var cardUnlockedTitleWrapper = "CardUnlocked-module--cardUnlockedTitleWrapper--Gc-z5";
export var cardUnlockedTitle = "CardUnlocked-module--cardUnlockedTitle--17tiN";
export var orange = "CardUnlocked-module--orange--2XRW5";
export var purple = "CardUnlocked-module--purple--hRJG6";
export var blue = "CardUnlocked-module--blue--2QtZ-";
export var cardUnlockedMain = "CardUnlocked-module--cardUnlockedMain--A-m0Z";
export var cardUnlockedDescription = "CardUnlocked-module--cardUnlockedDescription--NOCih";